function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState, useCallback } from 'react';
import { Carousel, Col } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Row } from 'react-bootstrap';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import PreviewEditReportTextButton from '../util/buttons/PreviewEditReportTextButton';
import RndCommentsModal from '../util/textEdit/modules/comments/RndCommentsModal';
import ReportDisplay from './ReportDisplay';
import CompanyReportPreviewEditSectionModal from './modal/CompanyReportPreviewEditSectionModal';
import ZoomControl from './ZoomControl';
export default function CompanyReportPreview(_ref) {
  let {
    reportTemplateId,
    claimId,
    claimGroup,
    changeSetContainingObject,
    shouldShowComments,
    previewRndReportFinalVersion,
    previewRndReportHighlightsVersion,
    EditProjectReportSliceModal
  } = _ref;
  const [pageCount, setPageCount] = useState(null);
  const [pageNumber, setPageNumber] = useState(1);
  const [reportHtml, setReportHtml] = useState(null);
  const [reportHtmlWithHighlights, setReportHtmlWithHighlights] = useState(null);
  const [displayedVersion, setDisplayedVersion] = useState('changes');
  const [editButtonsSettings, setEditButtonsSettings] = useState([]);
  const [editTextModalsSettings, setEditTextModalsSettings] = useState([]);
  const [visibleModalKey, setVisibleModalKey] = useState(undefined);
  const [activePageDomElement, setActivePageDomElement] = useState(null);
  const [commentSpanData, setCommentSpanData] = useState(null);
  const [showRndCommentsModal, setShowRndCommentsModal] = useState(false);
  const user = useSelector(state => state.auth.user);
  const [zoom, setZoom] = useState(100);
  const scale = zoom / 100;
  const {
    search
  } = useLocation(); //Required for Italy
  const report_type = new URLSearchParams(search).get('report_type');
  const [reportPreviewGenerateTimestamp, setReportPreviewGenerateTimestamp] = useState(null);
  const basePreviewWidth = 793;
  const basePreviewHeight = 1130;
  const previewWidth = `${basePreviewWidth * scale}px`;
  const previewHeight = `${basePreviewHeight * scale}px`;
  const dispatch = useDispatch();
  const resetPdfData = useCallback(() => {
    setReportHtml(null);
    setReportHtmlWithHighlights(null);
    setPageCount(null);
    setVisibleModalKey(undefined);
    setEditButtonsSettings([]);
    setEditTextModalsSettings([]);
  }, []);

  // On report template change - preview the report with highlights
  useEffect(() => {
    console.log('calling previewRndReportHighlightsVersion');
    resetPdfData();
    previewRndReportHighlightsVersion(report_type, setReportHtmlWithHighlights, setReportPreviewGenerateTimestamp);
  }, [dispatch, previewRndReportHighlightsVersion, claimId, resetPdfData, report_type]);

  // Once the preview with highlights is ready, preview the final version
  useEffect(() => {
    if (changeSetContainingObject.active_change_set) {
      previewRndReportFinalVersion(report_type, setReportHtml);
    }
  }, [dispatch, previewRndReportFinalVersion, reportPreviewGenerateTimestamp, changeSetContainingObject.active_change_set, report_type]);
  const createEditSectionModalSettings = useCallback((hookClass, modalTitle, footnoteStartIndex) => {
    let modalSettings = {
      reportTemplateId,
      isVisible: false,
      key: `${hookClass}-modal`,
      title: modalTitle,
      footnoteStartIndex,
      onHide: () => setVisibleModalKey(null),
      onContentChanged: () => {
        resetPdfData();
        previewRndReportHighlightsVersion(report_type, setReportHtmlWithHighlights, setReportPreviewGenerateTimestamp);
      }
    };
    let claimGroupId,
      projectId,
      sliceId,
      fieldId,
      reportTemplateCategoryId,
      templateIdFromClass = reportTemplateId,
      modalType,
      fieldName,
      companyId,
      businessUnitId,
      subsidiaryCompanyId;
    if (hookClass.includes('js-hook-ClaimGroup')) {
      claimGroupId = hookClass.split('-ClaimGroup-')[1].split('-')[0];
      projectId = hookClass.split('-Project-')[1].split('-')[0];

      // may not be defined if the js hook is for the project report name
      sliceId = hookClass.split('-Slice-')[1]?.split('-')[0];
      modalType = sliceId ? 'ProjectRemportSliceModal' : 'ProjectRemportNameModal'; // Default Project Report Slice Modal or project report name modal
    } else if (hookClass.includes('company-field')) {
      fieldName = hookClass.split('-field-')[1];
      modalType = 'ClaimGroupFieldModal';
    } else if (hookClass.includes('js-hook-Payment-Fields') || hookClass.includes('js-hook-ProjectReportFreeTextEdit')) {
      //Italy
      claimGroupId = hookClass.split('-ClaimGroup-')[1].split('-')[0];
      projectId = hookClass.split('-Project-')[1].split('-')[0];
      modalType = hookClass.includes('js-hook-Payment-Fields') ? 'paymentFields' : 'projectReportFreeTextEdit'; // Type of Project Report Slice Modal
    } else if (hookClass.includes('js-hook-Description-Fields')) {
      //Canada
      claimGroupId = hookClass.split('-ClaimGroup-')[1].split('-')[0];
      projectId = hookClass.split('-Project-')[1].split('-')[0];
      fieldId = hookClass.split('-Field-')[1].split('-')[0];
      modalType = 'descriptionFields'; // Type of Project Report Slice Modal
    } else if (hookClass.includes('js-hook-Business-Unit-Overview')) {
      companyId = hookClass.split('-Company-')[1].split('-')[0];
      businessUnitId = hookClass.split('-BusinessUnit-')[1].split('-')[0];
      modalType = 'businessUnitOverviewModal';
    } else if (hookClass.includes('js-hook-Subsidiary-Overview')) {
      companyId = hookClass.split('-Company-')[1].split('-')[0];
      subsidiaryCompanyId = hookClass.split('-SubsidiaryCompany-')[1].split('-')[0];
      modalType = 'subsidiaryOverviewModal';
    } else {
      reportTemplateCategoryId = hookClass.split('-category-')[1];
      templateIdFromClass = hookClass.split('-category-')[0].split('js-hook-Report-Template-')[1];
      modalType = 'ReportTemplateCategoryModal';
    }

    /** Some of these settings will be undefined, depending on the modal type */
    modalSettings = {
      modalType,
      ...modalSettings,
      sliceId,
      claimGroup,
      // some models expect the claim group object
      claimGroupId,
      // some models expect the claim group id
      businessUnitId,
      subsidiaryCompanyId,
      companyId,
      projectId,
      fieldId,
      fieldName,
      reportTemplateCategoryId,
      reportTemplateId: templateIdFromClass
    };
    return modalSettings;
  }, [reportTemplateId, claimGroup, resetPdfData, previewRndReportHighlightsVersion, report_type]);
  const createButtonAndModalSettingsForPage = useCallback(activePageDomElement => {
    setActivePageDomElement(activePageDomElement);
    const hookPoints = Array.from(activePageDomElement.querySelectorAll('[class*="js-hook-"]'));
    if (!hookPoints) {
      return;
    }
    const buttonsSettings = [];
    const modalsSettings = [];
    hookPoints.forEach(hookPoint => {
      const hookClass = Array.from(hookPoint.classList).find(c => c.startsWith('js-hook'));
      const {
        top,
        left
      } = hookPoint.getBoundingClientRect();
      const changeVsFinalVersionButtonsRowHeightPx = reportHtml ? 48 : 0;
      const previewSectionDistanceToIframeTop = 77 + changeVsFinalVersionButtonsRowHeightPx;
      const leftAlignPx = left * scale - 90;
      const companyFieldEditTextBtnLeftAlignPx = left * scale - 140;
      if (user.account_type === 'admin' || user.account_type === 'consultant' || user.account_type === 'manager' || changeSetContainingObject?.active_change_set?.review_type === 'client_review') {
        buttonsSettings.push({
          top: `${top * scale + previewSectionDistanceToIframeTop + hookPoint.offsetHeight * scale / 2}px`,
          left: hookClass.includes('-company-field-') ? `${companyFieldEditTextBtnLeftAlignPx}px` : `${leftAlignPx}px`,
          key: hookClass
        });
      }
      const modalTitleClass = Array.from(hookPoint.classList).find(c => c.startsWith('js-hook-title'));
      const modalTitle = modalTitleClass.split('js-hook-title-')[1].replaceAll('_', ' ');
      const footnoteStartIndex = parseInt(hookPoint.getAttribute('data-footnote-start-index') || 0);
      modalsSettings.push(createEditSectionModalSettings(hookClass, modalTitle, footnoteStartIndex));
    });
    if (changeSetContainingObject.active_change_set || user && (user.account_type !== 'customer' || user.account_type !== 'accountant')) {
      setEditTextModalsSettings([...modalsSettings]);
      setEditButtonsSettings([...buttonsSettings]);
    }
    // eslint-disable-next-line
  }, [changeSetContainingObject.active_change_set, createEditSectionModalSettings, reportHtml, user, scale]);
  function previousPage() {
    const newPageNumber = pageNumber === 1 ? pageCount : pageNumber - 1;
    setPageNumber(newPageNumber);
  }
  function nextPage() {
    const newPageNumber = pageNumber === pageCount ? 1 : pageNumber + 1;
    setPageNumber(newPageNumber);
  }
  const onCarouselSelect = (_, e) => {
    e.preventDefault();
    e.nativeEvent.preventDefault();

    // dont do anything unless the iframes are done loading and we know the page count
    if (pageCount) {
      let link = e.target;
      link = link.tagName === 'A' ? link : link.parentElement;
      link = link.tagName === 'A' ? link : link.parentElement;
      if (link.className.includes('carousel-control-prev')) {
        previousPage();
      } else if (link.className.includes('carousel-control-next')) {
        nextPage();
      }
    }
  };
  const createEditTextButton = settings => {
    const toggleHookHighlight = shouldHaveHighlight => {
      // hook text may flow to multiple pages in which case we have multiple hooks
      const hooks = Array.from(activePageDomElement.querySelectorAll(`.${settings.key}`));
      if (shouldHaveHighlight) {
        hooks.forEach(h => h.classList.add('preview-text--highlighted'));
      } else {
        hooks.forEach(h => h.classList.remove('preview-text--highlighted'));
      }
    };
    const button = /*#__PURE__*/React.createElement(PreviewEditReportTextButton, {
      settings: settings,
      toggleHookHighlight: toggleHookHighlight,
      setVisibleModalKey: setVisibleModalKey
    });
    return button;
  };
  const createEditTextButtons = editButtonsSettings => {
    const btnDimension = parseFloat(getComputedStyle(document.documentElement).fontSize) * 2 + 2; // + (10 /* offset from other buttons */)
    let lastSetting = null;
    editButtonsSettings.forEach(setting => {
      if (lastSetting) {
        const lastSettingPos = {
          top: parseFloat(lastSetting.top),
          left: parseFloat(lastSetting.left)
        };
        const settingPos = {
          top: parseFloat(setting.top),
          left: parseFloat(setting.left)
        };
        const overlapVertically = lastSettingPos.top + btnDimension >= settingPos.top && lastSettingPos.top <= settingPos.top + btnDimension;
        const overlapHorizontally = lastSettingPos.left + btnDimension >= settingPos.left && lastSettingPos.left <= settingPos.left + btnDimension;
        const btnsOverlap = overlapVertically && overlapHorizontally;
        if (btnsOverlap) {
          setting.top = `${lastSettingPos.top + btnDimension + 5}px`;
        }
      }
      lastSetting = setting;
    });
    return editButtonsSettings.map(createEditTextButton);
  };
  useEffect(() => {
    const getUpdatedModalSettings = editTextModalsSettings => {
      if (pageCount && visibleModalKey) {
        const modalSettings = editTextModalsSettings.find(s => s.key === visibleModalKey);
        modalSettings.isVisible = true;
      } else if (pageCount && visibleModalKey === null) {
        editTextModalsSettings.forEach(s => s.isVisible = false);
        if (activePageDomElement) {
          const hookPoints = Array.from(activePageDomElement.querySelectorAll('[class*="js-hook-"]'));
          hookPoints.forEach(h => h.classList.remove('preview-text--highlighted'));
        }
      }
      const vis = editTextModalsSettings.find(s => s.isVisible);
      console.log('returns updated modal settings where: ', vis.key, ' is visible');
      return [...editTextModalsSettings];
    };
    const shouldHideModal = visibleModalKey === null && editTextModalsSettings.some(s => s.isVisible);
    const shouldShowModal = visibleModalKey != null && editTextModalsSettings.every(s => !s.isVisible);
    if (shouldHideModal || shouldShowModal) {
      setEditTextModalsSettings(getUpdatedModalSettings(editTextModalsSettings));
    }
  }, [activePageDomElement, editTextModalsSettings, pageCount, visibleModalKey]);

  // functions passed to child components should be callbacks
  // as if there is a useEffect depending on an inline function it will be executed many times
  const onHtmlLoaded = useCallback(_ref2 => {
    let {
      pageCount
    } = _ref2;
    setPageCount(pageCount);
  }, []);
  const onPageChanged = useCallback((pageNumber, activePageDomElement) => {
    setPageNumber(pageNumber);
    createButtonAndModalSettingsForPage(activePageDomElement);
  }, [createButtonAndModalSettingsForPage]);
  const onCommentSpanClicked = useCallback(data => {
    setCommentSpanData(data);
    setShowRndCommentsModal(true);
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: 'ClaimPreview'
  }, reportHtmlWithHighlights && displayedVersion === 'changes' && (user.account_type !== 'accountant' || user.account_type !== 'customer') && createEditTextButtons(editButtonsSettings), reportHtmlWithHighlights && displayedVersion === 'changes' && editTextModalsSettings.map(settings => settings.isVisible ? /*#__PURE__*/React.createElement(CompanyReportPreviewEditSectionModal, _extends({
    changeSetContainingObject: changeSetContainingObject
  }, settings, {
    isUnderReview: !!reportHtml,
    EditProjectReportSliceModal: EditProjectReportSliceModal
  })) : /*#__PURE__*/React.createElement(React.Fragment, null)), showRndCommentsModal && /*#__PURE__*/React.createElement(RndCommentsModal, {
    show: showRndCommentsModal,
    commentTextSelectionData: commentSpanData,
    onHide: () => {
      setShowRndCommentsModal(false);
      resetPdfData();
      previewRndReportHighlightsVersion(report_type, setReportHtmlWithHighlights, setReportPreviewGenerateTimestamp);
    }
  }), reportHtmlWithHighlights ? /*#__PURE__*/React.createElement(React.Fragment, null, reportHtml && user.account_type !== 'customer' && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 3,
      offset: 3
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: displayedVersion === 'final' ? 'primary' : 'light',
    size: "md",
    onClick: () => setDisplayedVersion('final')
  }, "Show final")), /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 3
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: displayedVersion === 'changes' ? 'primary' : 'light',
    size: "md",
    onClick: () => setDisplayedVersion('changes')
  }, "Show changes"))))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 12
  }, /*#__PURE__*/React.createElement(Carousel, {
    interval: null,
    activeIndex: 0,
    onSelect: onCarouselSelect,
    nextIcon: /*#__PURE__*/React.createElement("span", {
      className: "material-icons text-primary",
      style: {
        height: '2rem',
        width: '2rem'
      }
    }, "chevron_right"),
    prevIcon: /*#__PURE__*/React.createElement("span", {
      className: "material-icons text-primary",
      style: {
        height: '2rem',
        width: '2rem'
      }
    }, "chevron_left")
  }, /*#__PURE__*/React.createElement(Carousel.Item, null, /*#__PURE__*/React.createElement("div", {
    style: {
      height: previewHeight,
      width: previewWidth,
      transition: 'all 0.2s ease',
      position: 'relative',
      overflow: 'hidden'
    }
  }, reportHtml && /*#__PURE__*/React.createElement(ReportDisplay, {
    mode: "report-final-version",
    previewWidth: `${basePreviewWidth}px`,
    previewHeight: `${basePreviewHeight}px`,
    scale: scale
    // zIndex here allows us to toggle between the html versions without the need of re-rendering on each toggle
    ,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: displayedVersion === 'final' ? 1 : 0
    },
    reportHtml: reportHtml,
    displayPageNumber: pageNumber,
    ignoreMessages: true,
    onHtmlLoaded: onHtmlLoaded
  }), /*#__PURE__*/React.createElement(ReportDisplay, {
    mode: "report-changes",
    allowComments: !!changeSetContainingObject.active_change_set,
    previewWidth: `${basePreviewWidth}px`,
    previewHeight: `${basePreviewHeight}px`,
    scale: scale
    // zIndex here allows us to toggle between the html versions without the need of re-rendering on each toggle
    ,
    style: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: displayedVersion === 'changes' ? 1 : 0
    },
    reportHtml: reportHtmlWithHighlights,
    displayPageNumber: pageNumber,
    onHtmlLoaded: onHtmlLoaded,
    onPageChanged: onPageChanged,
    onPageLoaded: createButtonAndModalSettingsForPage,
    onCommentSpanClicked: onCommentSpanClicked
  })))))), /*#__PURE__*/React.createElement(ZoomControl, {
    zoom: zoom,
    onZoomChange: setZoom
  })) : /*#__PURE__*/React.createElement(Loader, null));
}